<template>
    <div class="instant-messaging">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "instantMessaging",
    components: {},
}
</script>

<style scoped lang="less">
.instant-messaging {
    width: 100%;
    min-height: 100%;
    background: #F5F6F9;
    box-sizing: border-box;
    font-family: PingFangSC-Regular;
    padding: env(safe-area-inset-bottom); /* zero for all rectangular user agents */
    padding: env(Safe-area-inset-bottom); /* 50px because UA properties are case sensitive */
}
</style>
